
declare interface loggerParam{ 
  name: string,
  instName: string,
  instType:string,
  instServiceTime:string,
  instScale:string,
  instId:string,
  adminId: string,
  questionTitle: string,
  docId: string,
  dynamicId: string,
  title:string
}
function createLogger(loggerParam:loggerParam) { 
  window.logger.push("platform", "pc");
  window.logger.push("event", '埋点');
  window.logger.push("device", navigator.userAgent);
  // const content = label;
    window.logger.push("content", JSON.stringify({
      name:loggerParam.name,
      机构名称: loggerParam.instName,
      机构类型: loggerParam.instType,
      购买时长: loggerParam.instServiceTime,
      机构规模: loggerParam.instScale,
      instId:loggerParam.instId,
      adminId: loggerParam.adminId,
      questionTitle: loggerParam.questionTitle,
      docId: loggerParam.docId,
      dynamicId: loggerParam.dynamicId,
      title:loggerParam.title
      // ...mk
    }));
    // 记录日志
  window.logger.logger();
}
  
export default createLogger;

